export const REQUIRED_FIELDS_FETCH_START = 'REQUIRED_FIELDS_FETCH_START';
export const REQUIRED_FIELDS_FETCH_API = 'REQUIRED_FIELDS_FETCH_API';
export const REQUIRED_FIELDS_FETCH_API_FULFILLED = 'REQUIRED_FIELDS_FETCH_API_FULFILLED';
export const REQUIRED_FIELDS_FETCH_API_REJECTED = 'REQUIRED_FIELDS_FETCH_API_REJECTED';
export const REQUIRED_FIELDS_UPDATE = 'REQUIRED_FIELDS_UPDATE';
export const REQUIRED_FIELDS_UPDATE_START = 'REQUIRED_FIELDS_UPDATE_START';
export const REQUIRED_FIELDS_UPDATE_API = 'REQUIRED_FIELDS_UPDATE_API';
export const REQUIRED_FIELDS_UPDATE_API_FULFILLED = 'REQUIRED_FIELDS_UPDATE_API_FULFILLED';
export const REQUIRED_FIELDS_UPDATE_API_REJECTED = 'REQUIRED_FIELDS_UPDATE_API_REJECTED';

export const updateRequiredFields = (fieldName, isRequired) => ({
  type: REQUIRED_FIELDS_UPDATE,
  payload: {fieldName, isRequired}
});
